export default __webpack_public_path__ + "static/media/-W_8XJnvUD7dzB2Cy_gIfWMuUZctdhow.a0757896.woff2";